<template>
    <div class="box">

        <div class="box-header p-b-sm">
            <h2 class="title-color m-b-sm inline">
                Historia zamówień
                <span v-if="totalFound" class="label up blue">{{totalFound}}</span>
            </h2>
        </div>
        <div class="m-a-0 custom-divider"/>
        <table class="table table-bordered">
            <thead class="primary-color d-gray">
                <tr>
                    <th>Numer ZO</th>
                    <th>Produkty</th>
                    <th>Kwota</th>
                    <th>Data</th>
                    <th>Status</th>
                   
                </tr>
            </thead>
            <tbody v-if="!loadingData" class="primary-color">
                <tr v-for="(o, index) in orders" :key="index">
                    <td>
                        <router-link   target="_blank" :to="'/order/'+o._id">
                            {{ o.name }}
                        </router-link>
                    </td>
                    <td style="max-width: 300px;">
                        <ProductCodeBox :code="code" :qty="qty" v-for="(qty, code) in o.computed.productGroups" :key="code" />
                    </td>
                    <td>
                        <span v-if="o.computed && o.computed.totalPrice">
                            <span class="block">{{o.computed.totalPrice.netto | money(o.currency) }}</span>
                            <span class="text-xs text-muted" v-if="o.currency && o.currency != 'PLN'" >{{ o.computed.totalPrice.netto * o.exchangeRate | money("PLN") }}</span>
                            <span class="text-xs text-muted" v-else>{{ o.computed.totalPrice.brutto | money(o.currency) }} (brutto)</span>
                        </span>
                    </td>
                    <td>
                        <span>{{o.created | moment("DD/MM/YY  HH:mm")}}</span><br>
                        <span v-if="o.productionDate" class="label border-yellow text-yellow m-r-xs none-radius inline m-t-lg" title="Data wyprodukowania">
                        Na prod.: {{o.productionDate | moment("DD/MM/YY")}}
                        </span>
                    </td>
                    <td><OrderStatusSpan :order="o" /></td>
                </tr>
            </tbody>
        </table>
        <Spinner v-if="loadingData"/>
        <div class="row">
            <div class=" col-sm-12 text-right text-center-xs">
                <paginate
                    v-model="page"
                    :page-count="pages"
                    :click-handler="changePage"
                    :prev-text="'<'"
                    :next-text="'>'"
                    :container-class="'pagination pagination-sm m-r'"/>
            </div>
        </div>
    </div>
</template>
<script>
import Api from '../../Api.js';
import Spinner from '../Spinner.vue';
import ProductCodeBox from '../ProductCodeBox.vue';
import OrderStatusSpan from '../Order/OrderStatusSpan.vue';
const POS_PER_PAGE = 25;

export default {
    props: {
        customer: Object
    },
    name: 'CustomerOrderHistory',
    components: {
        Spinner,
        ProductCodeBox,
        OrderStatusSpan
    },
    data: function () {
        return {
            pages: 0,
            page: 1,
            offset: 0,
            loadingData: false,
            totalFound: null,
            orders: null
        }
    },
    created: function() {
        this.getOrders();
    },
    destroyed: function() {
    },
    computed: {

    },
    methods: {
        async getOrders() {
            this.loadingData = true;
            try {
                const res = await Api.order.getOrders({ customer: this.customer._id, computed: { productGroups: true, totalPrice: true }, offset: this.offset, limit: POS_PER_PAGE });
                this.orders = res.data;
                this.totalFound = res.total;
                this.pages = Math.ceil(res.total / POS_PER_PAGE);
            } catch (error) {
                this.$h.commonApiError(error, true);
            }
            this.loadingData = false;
        },
        changePage(pageNum) {
            this.offset = 0;
            if (pageNum > 1) this.offset = (pageNum * POS_PER_PAGE) - POS_PER_PAGE;
            this.getOrders();
        },
    }
}

</script>